import { render } from "./EchoDic.vue?vue&type=template&id=39a1f7e8"
import script from "./EchoDic.vue?vue&type=script&lang=js"
export * from "./EchoDic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__